/**
 * Cart URL redirect handler
 * Detects /cart in URL and redirects to home with cart drawer open
 */
(() => {
  // Function to open cart drawer
  const openCartDrawer = () => {
    // Wait for cart drawer component to be defined
    customElements.whenDefined('cart-drawer-component').then(() => {
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        // Remove the flag after opening
        sessionStorage.removeItem('openCartDrawer');
      }
    });
  };

  // Check immediately on script load (before page renders)
  const currentPath = window.location.pathname;
  
  // If we're on /cart, redirect immediately
  if (currentPath === '/cart' || currentPath.startsWith('/cart/')) {
    // Set flag to open cart drawer after redirect
    sessionStorage.setItem('openCartDrawer', 'true');
    // Redirect to home immediately
    window.location.replace('/');
    return; // Stop execution here
  }

  // Check if we need to open cart drawer after redirect
  if (sessionStorage.getItem('openCartDrawer') === 'true') {
    // Open cart drawer after page loads
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openCartDrawer);
    } else {
      openCartDrawer();
    }
  }
})();